// What the server tells the browser at startup (GET /api/config): the environment, the Sentry DSN and how admins
// sign in. Public values only. Reading them at runtime, not at build time, means one build serves every
// environment, and each environment's settings live in one place (its Cloudflare variables).

export type AuthConfig =
  | { mode: "clerk"; publishableKey: string }
  | { mode: "local" }
  | { mode: "unconfigured"; message: string };

export interface RuntimeConfig {
  environment: string;
  sentryDsn: string;
  auth: AuthConfig;
}

let pending: Promise<RuntimeConfig> | null = null;

/** Fetched once per page load. A failure isn't remembered, so trying again can succeed. */
export function loadRuntimeConfig(): Promise<RuntimeConfig> {
  pending ??= fetch("/api/config", { credentials: "same-origin" })
    .then(async (r) => {
      if (!r.ok) throw new Error(`The server's configuration couldn't be loaded (HTTP ${r.status}).`);
      return (await r.json()) as RuntimeConfig;
    })
    .catch((e) => { pending = null; throw e; });
  return pending;
}
